import React, { useState } from 'react';
import { Tabs } from 'antd';
import { UserOutlined, UserAddOutlined, HeartOutlined, TeamOutlined, RocketOutlined } from '@ant-design/icons';
import PageHeader from '../../../components/shared/PageHeader';

// Import components
import AcquisitionChart from './components/AcquisitionChart';
import RetentionAnalysis from './components/RetentionAnalysis';
import DemographicsChart from './components/DemographicsChart';
import EngagementMetrics from './components/EngagementMetrics';

const ClientAnalytics: React.FC = () => {
  const [activeTab, setActiveTab] = useState<string>('acquisition');

  const tabItems = [
    {
      key: 'acquisition',
      label: (
        <span>
          <UserAddOutlined />
          Client Acquisition
        </span>
      ),
      children: <AcquisitionChart />,
    },
    {
      key: 'retention',
      label: (
        <span>
          <HeartOutlined />
          Retention Analysis
        </span>
      ),
      children: <RetentionAnalysis />,
    },
    {
      key: 'engagement',
      label: (
        <span>
          <RocketOutlined />
          Engagement Metrics
        </span>
      ),
      children: <EngagementMetrics />,
    },
    {
      key: 'demographics',
      label: (
        <span>
          <TeamOutlined />
          Demographics
        </span>
      ),
      children: <DemographicsChart />,
    },
  ];

  return (
    <div>
      <PageHeader
        icon={<UserOutlined />}
        title="Client Analytics"
        subtitle="Comprehensive client behavior analysis, acquisition tracking, and performance insights"
      />

      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        type="card"
        items={tabItems}
      />
    </div>
  );
};

export default ClientAnalytics; 